import {useProductListView} from '@/_application/modules/products/provider/product-list-view.provider';
import {useProductsAggregations} from '@/framework/product';
import {RadioGroup} from '@headlessui/react';
import cn from 'classnames';
import {useEffect} from 'react';
import {HighlightBrand} from '@/__generated__/__types__';

interface IProps {
    brand: HighlightBrand;
    onFilterChange: (values: string[] | string, attributeCode: string) => void;
}

export const BrandProductsFilter = ({brand, onFilterChange}: IProps) => {
    const {fetchAggregation, data} = useProductsAggregations();
    const {filter} = useProductListView();
    const categoryFilter = data?.find(option => option.attribute_code === 'category_id');

    useEffect(() => {
        if (!brand?.label!) {
            return;
        }
        const filterBrand = {brand: {eq: brand?.label}};
        fetchAggregation({filter: filterBrand});
    }, [brand]);

    const handleChangeFilter = (value: string) => {
        onFilterChange([value], categoryFilter?.attribute_code!);
    };

    const categoryFilterValue = filter?.category_id?.in?.at(0);

    return (
        <div className="flex h-fit w-60 items-center justify-center gap-5 rounded-xl bg-white px-3 py-6">
            <RadioGroup value={categoryFilterValue} onChange={handleChangeFilter} className="flex flex-col gap-2">
                {categoryFilter?.options?.map((item: any) => (
                    <RadioGroup.Option key={`category-${item?.value}`} value={item?.value}>
                        {({active, checked}) => (
                            <div className="flex cursor-pointer items-center gap-2.5 py-1">
                                <div className="flex h-4 w-4 items-center justify-center rounded-full border border-KPZ_Border">
                                    <span
                                        className={cn('block h-3 w-3 rounded-full', {
                                            'bg-primary': checked,
                                            'bg-white': !checked,
                                        })}></span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="text-sm text-KPZ_text_1st">{item.label}</span>
                                </div>
                            </div>
                        )}
                    </RadioGroup.Option>
                ))}
            </RadioGroup>
        </div>
    );
};
